module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/m0nhLd/tc-custom/9781611521597.jpg?1723404796659",
      "alt": "This image is the cover for the book ROTC Ron"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("ROTC Ron\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Joe Barnes is infatuated with fellow college freshman Ron Driscoll. Ron is in the ROTC program and Joe starts to dress in military clothing to emulate his idol. But apart from discussions in philosophy class, Joe is too shy to speak to Ron, and Ron doesn’t break away from his circle of admirers long enough to notice that Joe is alive."), _c('br'), _c('br'), _vm._v("Joe all but throws himself at Ron during a discussion of Kant’s views on beauty. But Ron remains unaware of Joe’s feelings."), _c('br'), _c('br'), _vm._v("One Friday after class Joe visits the bathroom and finds himself blindfolded and put in handcuffs. Having a secret kink for bondage Joe is by turns scared and aroused."), _c('br'), _c('br'), _vm._v("Ron has planned a romantic and kinky weekend with Joe in the Allegheny mountains where soft rope will be needed, but clothes will not.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Drew Hunt\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0